import React from "react";
import shortcodeToEmoji from './shortcodeToEmoji.js';

function traverseAndReplaceEmojis(obj) {
  if (Array.isArray(obj)) {
    return obj.map(traverseAndReplaceEmojis);
  } else if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        newObj[key] = traverseAndReplaceEmojis(obj[key]);
      }
    }
    return newObj;
  } else {
    return replaceEmojis(obj);
  }
}

function replaceEmojis(text) {
  if (typeof text !== 'string') {
    return text;
  }
  // This regex matches any text between two colons, e.g., :smile:
  return text.replace(/:[^:\s]+:/g, (match) => {
    // Remove the surrounding colons from the match for lookup
    const emojiEntry = shortcodeToEmoji.shortcodeToEmoji[match];
    return emojiEntry ? emojiEntry.emoji : match;
  });
}

export { traverseAndReplaceEmojis };
